import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { SupplierProfile } from "./@types";

const fetchSupplier = async (code: string, subscription?: string) => {
  const supplier = await apiInputService.get(`/Supplier/supplierCode/${code}`, {
    params: { subscription },
  });
  const { data } = supplier;

  return data;
};

export const useSupplierByCode = (
  code: string,
  subscription?: string,
  options?: any
) => {
  return useQuery<SupplierProfile>(
    ["suppliers", code, subscription],
    () => fetchSupplier(code, subscription),
    {
      ...options,
      staleTime: Infinity,
    }
  );
};
